import React from 'react';
import Box from '@mui/material/Box';
import { LineChart } from '@mui/x-charts/LineChart';
import { MetricItem } from '../dataObjects/MailgunMetricsResponse';

const margin = { right: 24 };

interface dailyCountSummaryProps {
    items?: MetricItem[];
}


const EmailServerDailyLineChart = (props: dailyCountSummaryProps) => {

    let acceptedCount: number[] = [];
    let deliveredCount: number[] = [];
    let failedCount: number[] = [];
    let dates: string[] = [];

    const displayFormatedDate = (eventDate: string) => {

        const date = new Date(eventDate);
        const formatted = new Intl.DateTimeFormat("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric"
        }).format(date);

        return formatted;
    }

    if (props.items) {
        let items = props.items;
        items.forEach((item: MetricItem) => {
            acceptedCount.push(item.metrics.acceptedCount);
            deliveredCount.push(item.metrics.deliveredCount);
            failedCount.push(item.metrics.failedCount);
            let formattedDate = displayFormatedDate(item.dimensions ? item.dimensions[0].value: "");
            dates.push(formattedDate);
        }
        );
    }

    

    return (
        <Box sx={{ width: '90%', height: 300 }}>
            <LineChart
                series={[
                    { data: acceptedCount, label: 'Accepted' },
                    { data: deliveredCount, label: 'Delivered' },
                    { data: failedCount, label: 'Failed' }
                ]}
                xAxis={[{ scaleType: 'point', data: dates }]}
                margin={margin}
            />
        </Box>
    );
}

export default EmailServerDailyLineChart